module.exports = __webpack_public_path__ + "img/bg_yingshou.5f105460.png";